import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { getCurrentPath } from "@faire/web/common/Path";
import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useFilterStore } from "@faire/retailer/components/Filters/useFilterStore";
import { useTopOfPageContentStore } from "@faire/retailer/stores/ui/TopOfPageContentStore";

export const useFilterScrollToProducts = (
  scrollRef?: React.RefObject<HTMLDivElement>,
  isPageReady?: boolean
) => {
  const {
    data: { isNewFilterSelected, shouldScrollToResults },
  } = useFilterStore(["isNewFilterSelected", "shouldScrollToResults"]);

  const currentPath = getCurrentPath();
  const { replace } = useHistory();

  const { headerPlusPromoBannerHeight } = useTopOfPageContentStore([
    "headerPlusPromoBannerHeight",
  ]);

  const scrollToTop = useCallback(() => {
    if (currentPath.searchParams.get("scrollToResults")) {
      replace(currentPath.delete("scrollToResults").toString());
    }
    let offsetTop = 0;
    const marginTop = 16;
    if (scrollRef?.current?.offsetTop) {
      offsetTop =
        scrollRef.current.offsetTop - headerPlusPromoBannerHeight - marginTop;
    }
    getWindowOrThrow().scrollTo?.({
      top: offsetTop,
      behavior: "smooth",
    });
  }, [headerPlusPromoBannerHeight, scrollRef, currentPath, replace]);

  useEffect(() => {
    const isScrollableHeight =
      scrollRef?.current?.offsetTop && scrollRef?.current?.offsetTop > 200;
    if (isNewFilterSelected && shouldScrollToResults) {
      scrollToTop();
    } else if (
      currentPath.searchParams.get("scrollToResults") &&
      isPageReady &&
      isScrollableHeight
    ) {
      scrollToTop();
    }
  }, [
    scrollToTop,
    isNewFilterSelected,
    shouldScrollToResults,
    currentPath,
    replace,
    isPageReady,
    scrollRef,
  ]);
};
